export const GENDER_MALE = 1;
export const GENDER_FEMALE = 2;
export const GENDER_COUPLE = 3;
export const GENDER_TRANSVESTITE = 4;

export const GENDER_TEXT = {
    [GENDER_MALE]: 'Male',
    [GENDER_FEMALE]: 'Female',
    [GENDER_COUPLE]: 'Couple',
    [GENDER_TRANSVESTITE]: 'Transvestite'
};


// WEBPACK FOOTER //
// ./src/constants/genders.js